module.exports = __webpack_public_path__ + "img/john-accardo.15995615.jpg";